/**
 * A report's data-quality caveats (SPEC §9.6), as one list.
 *
 * The report route renders this under the title for every report. A bespoke
 * report listed in `CUSTOM_REPORTS_PLACING_CAVEATS` renders it itself instead,
 * wherever it puts its notes — the same component either way, so the two
 * placements cannot drift apart in what they say or how it looks.
 */

import { Info } from 'lucide-react'

/** The part of a caveat the list shows; `Caveat` from the payload satisfies it. */
export interface CaveatLine {
  readonly key: string
  readonly text: string
}

export function CaveatList({ caveats }: { caveats: readonly CaveatLine[] }) {
  if (caveats.length === 0) return null
  return (
    <ul className="space-y-1" data-testid="caveats">
      {caveats.map((caveat) => (
        <li
          key={caveat.key}
          className="flex items-start gap-2 text-[length:var(--text-xs)] text-[var(--color-ink-muted)]"
        >
          <Info aria-hidden className="mt-0.5 size-3.5 shrink-0" />
          <span>{caveat.text}</span>
        </li>
      ))}
    </ul>
  )
}
